import React from 'react';

const sectionBaseClass = 'rounded-3xl border border-slate-200 bg-white/95 p-6 shadow-sm sm:p-8';

const privacySections = [
  {
    title: 'Какие данные мы обрабатываем',
    body: 'Leikin Team обрабатывает данные, которые пользователь сам указывает в профиле и анкетах: имя, фамилию, email, телефон, дату рождения, спортивные и медицинские сведения, а также данные о регистрациях на тренировки, программы, события и заказы внутри сервиса.',
  },
  {
    title: 'Зачем мы используем данные',
    body: 'Данные используются для авторизации в приложении, ведения профиля спортсмена, записи на тренировки и мероприятия, оформления заказов, отображения персонального расписания и отправки сервисных уведомлений. Мы не продаём персональные данные третьим лицам.',
  },
  {
    title: 'Где хранятся данные',
    body: 'Данные хранятся в инфраструктуре Leikin Team и доступны только сотрудникам и подрядчикам, которым это необходимо для поддержки сервиса, тренировочного процесса и обработки пользовательских запросов.',
  },
  {
    title: 'Удаление аккаунта и запросы',
    body: 'Пользователь может запросить удаление аккаунта и связанных данных через приложение или написав в поддержку. По вопросам конфиденциальности можно обратиться по адресу info@leikinteam.co.',
  },
];

const supportSections = [
  {
    title: 'Поддержка Leikin Team',
    body: 'Если у вас возникли проблемы со входом, оплатой, регистрацией на тренировки, отображением расписания или работой мобильного приложения, свяжитесь с нами любым удобным способом.',
  },
  {
    title: 'Как связаться',
    body: 'Email: info@leikinteam.co. WhatsApp: +972 54 543-10-09. Instagram: @leikin_team. В обращении укажите модель устройства, версию iOS и краткое описание проблемы — это ускорит решение.',
  },
  {
    title: 'Что приложить к обращению',
    body: 'Если ошибка воспроизводится стабильно, добавьте скриншот, описание последовательности действий и email аккаунта, с которым вы входили в приложение. Для проблем с заказами и регистрациями приложите дату и время действия.',
  },
];

const contentMap = {
  privacy: {
    eyebrow: 'Leikin Team',
    title: 'Политика конфиденциальности',
    description: 'Эта страница описывает, какие данные мобильное приложение Leikin Team использует для авторизации, работы профиля спортсмена, регистрации на тренировки и сопровождения пользователей.',
    sections: privacySections,
  },
  support: {
    eyebrow: 'Leikin Team',
    title: 'Поддержка приложения',
    description: 'Контакты и порядок обращения по вопросам работы мобильного приложения, авторизации, тренировок, событий и заказов.',
    sections: supportSections,
  },
};

export default function LegalPage({ page = 'privacy' }) {
  const content = contentMap[page] || contentMap.privacy;

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(72,151,210,0.18),_transparent_45%),linear-gradient(180deg,_#f8fbff_0%,_#eef5fb_100%)]">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mb-10 rounded-[2rem] bg-slate-950 px-6 py-8 text-white shadow-[0_30px_80px_rgba(15,23,42,0.18)] sm:px-8">
          <p className="text-sm uppercase tracking-[0.28em] text-sky-200">{content.eyebrow}</p>
          <h1 className="mt-4 text-3xl font-semibold sm:text-4xl">{content.title}</h1>
          <p className="mt-4 max-w-3xl text-base leading-7 text-slate-200">{content.description}</p>
        </div>

        <div className="space-y-6">
          {content.sections.map((section) => (
            <section key={section.title} className={sectionBaseClass}>
              <h2 className="text-xl font-semibold text-slate-900">{section.title}</h2>
              <p className="mt-3 text-base leading-7 text-slate-700">{section.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
